import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { uploadMaterials } from '../../common/tests/actions'
import { Title } from '../components'
import { TextInput } from '../components/fields'

class StaticPageTestUpload extends React.Component {
  state = {
    materials: [],
    email: '',
    sent: false,
  }

  onFileChange = e => {
    const { materials } = this.state
    const newFiles = e.target.files

    this.setState({
      materials: [...materials, ...newFiles],
    })
  }

  send() {
    const { uploadMaterials } = this.props
    const { materials, email } = this.state

    uploadMaterials({ materials, email })

    this.setState({ sent: true })
  }

  render() {
    const { intl } = this.props
    const { email, materials, sent } = this.state

    return (
      <div className="static static-upload">
        <Title message="Vobo" />
        <div className="landing">
          <div className="landing-content">
            <h2 className="landing-quote">
              {intl.formatMessage(messages.quoteUpload)}
            </h2>
            <p className="landing-description">
              {intl.formatMessage(messages.descriptionUpload)}
            </p>
            {
              sent ?
                <React.Fragment>
                  <p className="landing-thanks">
                    {intl.formatMessage(messages.uploadedThanks)}
                  </p>
                  <Link to="/first-test">
                    <button className="button start-button big-button">
                      {intl.formatMessage(messages.thanksCta)}
                    </button>
                  </Link>
                </React.Fragment>
              :
                <React.Fragment>
                  <div className="files-picker">
                    <input
                      id="file"
                      type="file"
                      name="file"
                      multiple
                      onChange={this.onFileChange}
                    />
                    <label htmlFor="file">
                      {intl.formatMessage(messages.addFiles)}
                    </label>
                    <div>
                      {
                        materials.length ?
                          materials.map(file => (
                            <p key={file.name}>
                              {file.name}
                            </p>
                          ))
                        :
                          <p>
                            {intl.formatMessage(messages.pickFilesPlaceholder)}
                          </p>
                      }
                    </div>
                  </div>
                  <TextInput
                    value={email}
                    placeholder={intl.formatMessage(messages.emailPlaceholder)}
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                  <button
                    className="button start-button big-button"
                    onClick={() => this.send()}
                  > 
                    {intl.formatMessage(messages.ctaUpload)}
                  </button>
                </React.Fragment>
            }
          </div>
          <div className="flex-column">
            <img
              alt="Computer room"
              className="computer-room-landing"
              src="/assets/images/computer-room.png"
            />
          </div>
        </div>
      </div>
    )
  }
}

StaticPageTestUpload.defaultProps = {
  viewer: null,
}

StaticPageTestUpload.propTypes = {
  intl: PropTypes.object.isRequired,
  uploadMaterials: PropTypes.func.isRequired,
  viewer: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
  }), { uploadMaterials }),
  injectIntl,
)

export default enhance(StaticPageTestUpload)

const messages = defineMessages({
  quoteUpload: {
    id: 'static.page.quoteUpload',
    defaultMessage: 'Vytvoríme online test pre Vás',
  },
  descriptionUpload: {
    id: 'static.page.descriptionUpload',
    defaultMessage: 'Nahrajte sem Vaše materiály s cvičeniami a my vytvoríme test pre Vašich žiakov. Keď test vytvoríme pošleme Vám webovú adresu kde žiaci vyplnia test a vy si zobrazíte výsledky.',
  },
  emailPlaceholder: {
    id: 'static.page.emailPlaceholder',
    defaultMessage: 'Váš email',
  },
  addFiles: {
    id: 'static.page.addFiles',
    defaultMessage: '+ Nahrať súbory',
  },
  pickFilesPlaceholder: {
    id: 'static.page.pickFilesPlaceholder',
    defaultMessage: 'Vyberte súbory s cvičeniami a riešeniami',
  },
  uploadedThanks: {
    id: 'static.page.uploadedThanks',
    defaultMessage: 'Ďakujeme, za krátko Vás budeme kontaktovať. Zatiaľ môžete prezerať už vytvorené materiály.',
  },
  thanksCta: {
    id: 'static.page.thanksCta',
    defaultMessage: 'Zobraziť cvičenia',
  },
  ctaUpload: {
    id: 'static.page.ctaUpload',
    defaultMessage: 'Vytvoriť test',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/StaticPageTestUpload.js